import styled from "styled-components";

export const ModalConfirmContent = styled.div`
  gap: 4px;
  display: flex;
  padding: 40px 0 10px;
  font-size: 1.6rem;
  line-height: 150%;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  span {
    color: ${(props) => props.theme.colors.red100};
    font-size: 1.3rem;
    line-height: 150%;
  }
`;
